<template>
  <form method="post" ref="payment-form" id="payment-form" @submit.prevent="creatBrainTreeOrder">
    <section>
      <!-- <label for="amount"> -->
        <!-- <span class="input-label">Amount</span> -->
        <!-- <div class="input-wrapper amount-wrapper"> -->
          <!-- <input id="amount" name="amount" type="tel" min="1" placeholder="Amount" value="10"> -->
        <!-- </div> -->
      <!-- </label> -->

      <div class="bt-drop-in-wrapper">
        <div id="btdropin"></div>
      </div>
    </section>

    <input id="nonce" name="payment_method_nonce" type="hidden" />
    <button id="test" type="submit"><span>{{$t('Transaction')}}</span></button>
    <input id="btnSub" class="button" ref="btnSub" type=button v-show="false" @click="creatBrainTreeOrder" />
  </form>
</template>
<script>
  import { creatBrainTreeOrder } from '../api'
  export default {
    props:{
      token:{
        type:String,
      }
    },
    data(){
      return{
        client_token:"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",
        value:undefined
      }
    },
    mounted(){
      this.init()
    },
    methods:{
      init(){
        var form = document.querySelector('#payment-form');
        var value = undefined
        braintree.dropin.create({
          authorization: this.token,
          selector: '#btdropin',
          paypal:false
          // paypal: {
          //   flow: 'vault'
          // }
        },(createErr, instance) => {
          if (createErr) {
            // console.log('Create Error', createErr);
            return;
          }
          form.addEventListener('submit', function (event) {
            event.preventDefault();

            instance.requestPaymentMethod(function (err, payload) {
              if (err) {
                // console.log('Request Payment Method Error', err);
                return;
              }

              // Add the nonce to the form and submit
              // document.querySelector('#nonce').value = payload.nonce;
              value = payload.nonce;
              // if(document.querySelector('#nonce').value){
                if(value){
                  creatBrainTreeOrder({
                    order_no: sessionStorage.getItem('order_no'),
                    payment_method_nonce : value
                  }).then(res => {
                    if(res.cashierUrl){
                      location.href = res.cashierUrl
                    }
                  })
                }else{

                }
              // }
              // form.submit();
            });
          })
        })
      },
      creatBrainTreeOrder(){
      //   console.log(document.querySelector('#nonce').value,'document.querySelecto.value');
      //   console.log(this.value);
      //   if(this.value){
      //     creatBrainTreeOrder({
      //       order_no: sessionStorage.getItem('order_no'),
      //       payment_method_nonce : this.value
      //     }).then(res => {
      //       console.log(res,'结果');
      //     })
      //   }else{

      //   }

      }
    }
  }
</script>
<style lang="less" scoped>
  button{
      /*消除button的默认样式*/
      /*这种写法是对所有的button标签同时生效*/
      margin: 0px;
      padding: 0px;
      /*自定义边框*/
      border: 0px;
      /*消除默认点击蓝色边框效果*/
      outline: none;
  }
#test{
  cursor: pointer;
  font-size: 16px;
  background-color: #5CD493;
  padding: 10px 50px;
  border-radius: 5px;
  color: #fff ;
  span{
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,Cantarell,'Fira Sans','Droid Sans','Helvetica Neue',sans-serif !important;
  }
}
#test:hover{
  color: #359460;
  background-color: rgba(92,212,147,0.6);
}
//隐藏Paypal
.braintree-option__paypal{
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dropin.vue